import React, { useEffect } from 'react';
import { Tabs, TabList, TabPanel, Tab } from 'react-tabs';
import { User, Settings } from 'react-feather';
import QuckSellForm from './quckSellForm';
import { queryString } from './../../utils/queryString';
import EditProfile from './editProfile';
import ChangePassword from './changePassword';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import capitalizeFirstLetter from '../../utils/capitalizeFirstLetter';
import RakeSettings from './rakeSettings';
import PriceIncreaseForm from './priceIncreament';
import MaintenanceMode from './MaintenanceMode';
const TabsetProfile = ({ handleEdit, handleUpdate }) => {
  const { tab } = queryString();
  const history = useHistory();
  const result = useSelector((state) => state.admin);
  const { loginAdmin } = result || {};
  const { role } = loginAdmin || [];

  useEffect(() => {
    if (role?.length > 0) {
      let chekPer = role?.some((r) =>
        [
          'suUsers',
          'superAdmin',
          `write${capitalizeFirstLetter(tab)}`,
          `read${capitalizeFirstLetter(tab)}`,
        ].includes(r)
      );

      if (!chekPer && tab === 'profile') {
        history.push('/dashboard');
      } else if (!chekPer && tab === 'changePassword') {
        history.push('/dashboard');
      } else if (!chekPer && tab === 'quickSellPercentage') {
        history.push('/dashboard');
      } else if (!chekPer && tab === 'otherSettings') {
        history.push('/dashboard');
      } else if (!chekPer && tab === 'hideRolChance') {
        history.push('/dashboard');
      } else if (!chekPer && tab === 'hideTryForFree') {
        history.push('/dashboard');
      } else if (!chekPer && tab === 'paymentOptions') {
        history.push('/dashboard');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Tabs>
        <TabList className='nav nav-tabs tab-coupon'>
          {role?.some((r) =>
            [
              'suUsers',
              'superAdmin',
              'readProfile',
              'writeProfile',
              'readSetting',
              'writeSetting',
            ].includes(r)
          ) &&
            tab === 'profile' && (
              <Tab className='nav-link'>
                <User className='mr-2' />
                Profile
              </Tab>
            )}

          {role?.some((r) =>
            [
              'suUsers',
              'superAdmin',
              'readChangePassword',
              'writeChangePassword',
              'readSetting',
              'writeSetting',
            ].includes(r)
          ) &&
            tab === 'changePassword' && (
              <Tab className='nav-link'>
                <Settings className='mr-2' />
                Change Password
              </Tab>
            )}

          {tab === 'preferences' && (
            <Tab className='nav-link'>
              <Settings className='mr-2' />
              Quick Sell Percentage
            </Tab>
          )}
          {tab === 'preferences' && (
            <Tab className='nav-link'>
              <Settings className='mr-2' />
              Rake Settings
            </Tab>
          )}

          {tab === 'preferences' && (
            <Tab className='nav-link'>
              <Settings className='mr-2' />
              Price Increment
            </Tab>
          )}
          {tab === 'preferences' && (
            <Tab className='nav-link'>
              <Settings className='mr-2' />
              Maintenance Mode
            </Tab>
          )}
          {/* {tab === 'preferences' && (
            <Tab className='nav-link'>
              <Settings className='mr-2' />
              Delivery Management
            </Tab>
          )} */}
        </TabList>
        {role?.some((r) =>
          [
            'suUsers',
            'superAdmin',
            'readProfile',
            'writeProfile',
            'readSetting',
          ].includes(r)
        ) &&
          tab === 'profile' && (
            <TabPanel>
              <EditProfile
                handleUpdate={handleUpdate}
                handleEdit={handleEdit}
              />
            </TabPanel>
          )}

        {role?.some((r) =>
          [
            'suUsers',
            'superAdmin',
            'readChangePassword',
            'writeChangePassword',
            'readSetting',
            'writeSetting',
          ].includes(r)
        ) &&
          tab === 'changePassword' && (
            <TabPanel>
              <ChangePassword />
            </TabPanel>
          )}

        {tab === 'preferences' && (
          <TabPanel>
            <div className='account-setting'>
              <h5 className='f-w-600 f-16'>Quick Sell Percentage</h5>
              <QuckSellForm />
            </div>
          </TabPanel>
        )}
        {tab === 'preferences' && (
          <TabPanel>
            <div className='account-setting'>
              {/* <h5 className='f-w-600 f-16'>Quick Sell Percentage</h5> */}
              <RakeSettings />
            </div>
          </TabPanel>
        )}

        {tab === 'preferences' && (
          <TabPanel>
            <div className='account-setting'>
              <h5 className='f-w-600 f-16'>Price Increment</h5>
              <PriceIncreaseForm />
            </div>
          </TabPanel>
        )}
        {/* {tab === 'preferences' && (
          <TabPanel>
            <div className='account-setting'>
              <h5 className='f-w-600 f-16'>Other Setting</h5>
              <OtherSettingForm />
            </div>
          </TabPanel>
        )} */}
        {/* {tab === 'preferences' && (
          <TabPanel>
            <div className='account-setting'>
              <h5 className='f-w-600 f-16'>Hide Rol Chance</h5>
              <HideRollChance />
            </div>
          </TabPanel>
        )} */}

        {tab === 'preferences' && (
          <TabPanel>
            <div className='account-setting'>
              <h5 className='f-w-600 f-16'>Hide Try For Free Roll</h5>
              <MaintenanceMode />
            </div>
          </TabPanel>
        )}

        {/* {tab === 'preferences' && (
          <TabPanel>
            <div className='account-setting'>
             
              <ShippingManagement />
            </div>
          </TabPanel>
        )} */}

        {/* {tab === 'preferences' && (
          <TabPanel>
            <div className='account-setting'>
              <h5 className='f-w-600 f-16'>Payment Option</h5>
              <PaymentOption />
            </div>
          </TabPanel>
        )} */}
      </Tabs>
    </div>
  );
};

export default TabsetProfile;
